import { siteInfo } from '@/mocks/siteInfo';

export default function StatsSection() {
  const stats = [
    { value: siteInfo.stats.totalContent, label: '精选内容', icon: 'ri-film-line' },
    { value: siteInfo.stats.dailyUpdates, label: '每日更新', icon: 'ri-refresh-line' },
    { value: siteInfo.stats.activeUsers, label: '活跃用户', icon: 'ri-user-heart-line' },
    { value: siteInfo.stats.satisfaction, label: '用户满意度', icon: 'ri-emotion-happy-line' },
  ];

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-sm font-medium text-accent-600 mb-3">平台数据</p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">用数据说话</h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, i) => (
            <div key={i} className="text-center p-6 rounded-xl bg-background-100">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-accent-100">
                <i className={`${stat.icon} text-xl text-accent-600`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-1">{stat.value}</div>
              <div className="text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}